import { Avatar } from '@mui/material';

// colour should be a mui colour prop

interface UserAvatarProps {
  initials?: string;
  avatarUrl?: string;
  size?: 'small' | 'medium' | 'large';
  color?: string;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ initials, avatarUrl, size = 'medium', color }) => {
  const avatarSize = size === 'small' ? 32 : size === 'medium' ? 40 : 64;
  const fontSize = size === 'small' ? 16 : size === 'medium' ? 20 : 24;

  return (
    <Avatar
      sx={{ width: avatarSize, height: avatarSize, bgcolor: color, fontSize }}
      alt="User Avatar"
    >
      {avatarUrl ? (
        <img src={avatarUrl} alt="User Avatar" style={{ width: '100%', height: '100%' }} />
      ) : (
        (initials?.[0] || '')?.toUpperCase() + (initials?.[1] || '')?.toUpperCase()
      )}
    </Avatar>
  );
};

export default UserAvatar;
